import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  VisuallyHidden,
} from '@chakra-ui/react';
import FormElement from '@components/presentational/Form/FormElement';
import { PiMagnifyingGlassThin } from 'react-icons/pi';

export default function SearchBar({
  placeholder = 'Rechercher',
  hiddenAccessibleText = 'Lancez la recherche',
  size = 'md',
  search = '',
  onChange = null,
  debounce = 0,
}: {
  placeholder?: string;
  hiddenAccessibleText?: string;
  size?: string;
  search?: string;
  onChange?: Function;
  debounce?: number;
}) {
  const isFirstRender = useRef(true);
  const [typedSearch, setTypedSearch] = useState(search);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (!onChange) {
      return;
    }
    if (!debounce) {
      onChange(typedSearch);
      return;
    }
    const handler = setTimeout(() => {
      onChange(typedSearch);
    }, debounce);

    return () => {
      clearTimeout(handler);
    };
  }, [typedSearch]);
  useEffect(() => {
    setTypedSearch(search);
  }, [search]);
  return (
    <FormElement label={placeholder} isLabelVisuallyHidden>
      <InputGroup size={size}>
        <Input
          pr="2.5rem"
          type="search"
          placeholder={placeholder}
          fontSize={size === 'sm' ? '0.6875rem' : '1rem'}
          title={placeholder}
          aria-label={placeholder}
          value={typedSearch}
          onChange={e => {
            setTypedSearch(e.target.value);
          }}
        />
        <InputRightElement>
          <Button
            p=".25rem"
            aspectRatio="1 / 1"
            minWidth={size === 'sm' ? 'revert' : '2rem'}
            height="auto"
          >
            <VisuallyHidden>{hiddenAccessibleText}</VisuallyHidden>
            <Icon as={PiMagnifyingGlassThin} color="white.100" />
          </Button>
        </InputRightElement>
      </InputGroup>
    </FormElement>
  );
}
